export default [
  {
    id: 'life-1kbplus',
    name: 'Life 1 kb Plus',
    bands: [
      100, 200, 300, 400, 500, 650, 850, 1000, 1650, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000,
      11000, 12000,
    ],
  },
  {
    id: 'life-lambda',
    name: 'Life \u03BB DNA-HindIII',
    bands: [125, 564, 2027, 2322, 4361, 6557, 9416, 23130],
  },
  {
    id: 'life-50bp',
    name: 'Life 50 bp',
    bands: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 2652],
  },
  {
    id: 'neb-2log',
    name: 'NEB 2-Log',
    bands: [
      100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1517, 2017, 3001, 4001, 5001, 6001, 8001,
      10002,
    ],
  },
  {
    id: 'bioline-1kbplus',
    name: 'Bioline HyperLadder 1 kb Plus',
    bands: [250, 500, 700, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 600, 8000, 10000, 12007],
  },
  {
    id: 'thermo-1kbplus',
    name: 'GeneRuler 1 kb Plus',
    bands: [75, 200, 300, 400, 500, 700, 1000, 1500, 2000, 3000, 4000, 5000, 7000, 10000, 20000],
  },
];
